import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import PromoCodeForm from './PromoCodeForm'
import * as fromService from '@src/redux/modules/service'
import * as localStorage from 'utils/localStorage'

const PromoCodeFormContainer = reduxForm({
  form: 'promoCode'
})(PromoCodeForm)

const mapStateToProps = (state, ownProps) => {
  const {
    promoCode,
    redeemingPromoCode
  } = fromService.getState(state)

  const initialValues = {
    code: ''
  }

  const promoCodeFromLocalStorage = localStorage.getItem('aliada_promoCode')
  if (promoCodeFromLocalStorage) {
    initialValues.code = promoCodeFromLocalStorage
  }

  return {
    promoCode,
    redeemingPromoCode,
    initialValues
  }
}

const mapDispatchToProps = {
  redeemPromoCode: fromService.redeemPromoCode
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromoCodeFormContainer)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/components/PromoCodeForm/PromoCodeFormContainer.js